<template>
	<modal-box @close="close" :header="`${params.action} ${$t('labels.general.contact')}`" subHeader="Watch Profile" class="watch-profile-contact-form">
		<spinner v-if="model.loading"/>
		<error-box v-else-if="model.error" :error="model.error"/>
		<form v-else @submit.prevent="validateAndSubmit">
			<input-select v-model="model.data.type" :options="options" name="contact_type" :placeholder="$t('labels.general.type')" rules="required"/>
			<input-text v-model="model.data.contact" name="contact_contact" :placeholder="$t('labels.general.contact')" rules="required"/>
			<error-box v-if="form.error" :error="form.error"/>
			<div class="form-group-actions">
				<button-submit-icon-text :loading="form.loading" icon="save">{{ $t('buttons.general.save') }}</button-submit-icon-text>
			</div>
		</form>
	</modal-box>
</template>

<script>
import ApiObject from '@/classes/api/ApiObject'
import { mapGetters, mapActions } from 'vuex'
export default {
	props: [
		'user_uid',
		'watch_id',
		'params'
	],
	data () {
		return {
			patient: {},
			model: new ApiObject(),
			form: {
				loading: false,
				error: ''
			},
			options: [
				{ value: 'phone', text: 'Phone' },
				{ value: 'email', text: 'Email' },
				{ value: 'address', text: 'Address' }
			]
		}
	},
	methods: {
		validateAndSubmit () {
			this.$validator.validateAll()
				.then(result => {
					if (result) this.submit()
				})
		},
		submit () {
			switch (this.params.action) {
				case 'add':
					this.addContact()
					break
				case 'edit':
					this.editContact()
					break
				default:
					this.$log.warn('watch profile contact form', 'action not set')()
			}
		},
		close (reload = false) {
			this.$emit('close', { reload })
		},
		getContact () {
			this.model.loading = true
			this.$api.profile.contacts.get(this, this.user_uid, this.watch_id, this.params.id)
				.then(response => {
					this.$log.info('watch profile contact form', 'profile.contacts.get OK', response)()
					this.model.data = response.body
				}).catch(error => {
					this.$log.error('watch profile contact form', 'profile.contacts.get ERROR', error)()
					this.model.error = error
				}).finally(() => {
					this.model.loading = false
				})
		},
		async addContact() {
			this.form.loading = true
			const contact = Object.assign({ virtual_watch_id: this.patient.id }, this.model.data)
			try
			{
				await this.contactPut({ refThis: this, contact })
				this.$root.$emit('add-floating-box', { type: 'success', title: 'Success', message: 'Contact save with success.' })
			}
			catch (ex)
			{
				this.$root.$emit('add-floating-box', { type: 'error', title: 'Error', message: 'Issue when try to save contact. Try again please.' })
			}
			this.form.loading = false
			this.close(true)
		},
		async editContact() {
			this.form.loading = true
			const contact = Object.assign({ virtual_watch_id: this.patient.id }, this.model.data)
			try
			{
				await this.contactPost({ refThis: this, contact })
				this.$root.$emit('add-floating-box', { type: 'success', title: 'Success', message: 'Contact save with success.' })
			}
			catch (ex)
			{
				this.$root.$emit('add-floating-box', { type: 'error', title: 'Error', message: 'Issue when try to save contact. Try again please.' })
			}
			this.form.loading = false
			this.close(true)
		},
		...mapActions({
			contactPut: 'CONTACT_PUT',
			contactPost: 'CONTACT_POST',
		})
	},
	computed: {
		...mapGetters({
			getPatient: 'PATIENT',
			getContacts: 'PATIENTS_CONTACTS'
		})
	},
	created () {
		this.patient = this.getPatient(parseInt(this.watch_id))
		switch (this.params.action) {
			case 'add':
				this.model.data = {
					type: '',
					contact: ''
				}
				break
			case 'edit':
				this.getContact()
				break
			default:
				this.$log.warn('watch profile contact form', 'action not set')()
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/watch/profile/watchProfile/WatchProfileContactsForm.vue